import NodeHandlerBase from './node-handler-base';

export default class InsightsNodeHandler extends NodeHandlerBase {
  constructor(ctx, nodeType) {
    super(ctx, nodeType);
    this.tracking = ctx.$tracking;
  }

  trackResponseEvent(topic, event, trackConversationId = true) {
    if (this.store.getters['chatbotStore/isPreview']) return;

    let responseEvent = event;

    if (trackConversationId) {
      responseEvent = { ...responseEvent, conversationId: this.store.getters['chatbotStore/currentConversationId'] };
    }

    this.tracking?.sendResponseEvent(topic, responseEvent);
  }
}
